import script from "./MitikuinSecccionOne.vue?vue&type=script&setup=true&lang=js"
export * from "./MitikuinSecccionOne.vue?vue&type=script&setup=true&lang=js"

import "./MitikuinSecccionOne.vue?vue&type=style&index=0&id=1179ba4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1179ba4f"]])

export default __exports__